//
// Reel Animation
//
// Used to animate reel symbols
//

reelAnimationManager = {};
reelAnimationManager.animationStrips = [];

reelAnimationManager.createAnimationStrip = function(json) {

    if ( checkForUndefined(json.reel, "Reel animation strip needs to be linked to a reel using 'reel' parameter in layout.json")) {
        return;
    }

    var appertureHeight = resourceManager.get(json.reel).configParams.appertureHeight;
    var symbolTemplate = resourceManager.getConfiguration().symbols;
    var keys = Object.keys(symbolTemplate);

    var animationStrip = new PIXI.Container();
    animationStrip.reelAnimations = [];
    animationStrip.symbolLUT = {};

    for (var i = 0; i < keys.length; i++) {
        var template = symbolTemplate[keys[i]];
        animationStrip.symbolLUT["ID"+template.ID] = i;
    }

    for (var i = 0; i < appertureHeight; i++) {
        animationStrip.reelAnimations.push(undefined);
    }

    animationStrip.stopAnimation = function(index) {
        animationStrip.reelAnimations[index].stop();
    };

    animationStrip.isAnimationPlaying = function(index) {
		var strip = animationStrip.reelAnimations[index];
		if (strip === undefined)
			return false;
        
		return strip.playing;
    };

    animationStrip.showAnimation = function(index, animationID, frame, play) {
        // Convert symbol ID to index
        var animationIndex = animationStrip.symbolLUT["ID"+animationID];
        var symbolTemplate = resourceManager.getConfiguration().symbols;
        var symbolName = Object.keys(symbolTemplate)[animationIndex];

        // Check if a movie is already playing at this position
        if (animationStrip.reelAnimations[index] !== undefined) return;

        if (animationStrip.linkedReel.configParams.autoUpdateClipRect) {
            animationStrip.linkedReel.expandAnimationClipRect();
        }

		animationStrip.playAnimation(index, symbolName, frame, play);
    };
	
	animationStrip.hideAnimation = function(index) {
		if (animationStrip.reelAnimations[index] !== undefined) {
			animationStrip.stopAnimation(index);
			standardObjectFactory.destroyMovie(animationStrip.reelAnimations[index]);
			animationStrip.removeChild(animationStrip.reelAnimations[index]);
			animationStrip.reelAnimations[index] = undefined;
		}
	};
	
	animationStrip.playAnimation = function(index, movieName, frame, play) {
        var movieDef = resourceManager.getConfiguration().movieDefinitions[movieName];
		
		var offset = { x: 0.0, y: 0.0 };
		if (typeof(movieDef.offset) !== "undefined") {
			offset.x = movieDef.offset.x;
			offset.y = movieDef.offset.y;
		}
		
		var scale = { x: 1.0, y: 1.0 };
		if (typeof(movieDef.scale) !== "undefined") {
			scale.x = movieDef.scale.x;
			scale.y = movieDef.scale.y;
		}
		
        play = (play === undefined) ? true : play;
        frame = (frame === undefined) ? 0 : frame;
		var loop = (movieDef.loop === undefined) ? false : movieDef.loop;

        animationStrip.reelAnimations[index] = standardObjectFactory.createMovie( { definition: movieName } );
        animationStrip.reelAnimations[index].anchor.set(0.5, 0.5);
		animationStrip.reelAnimations[index].scale.set(scale.x, scale.y);
        animationStrip.reelAnimations[index].loop = loop;
        animationStrip.reelAnimations[index].position.x = (offset.x / resourceManager.selectedAssetResolution.scaleFactor);
        animationStrip.reelAnimations[index].position.y = (((reelManager.reels[0].configParams.appertureSpacing * (index + 0.5)) + offset.y) / resourceManager.selectedAssetResolution.scaleFactor);
		
        if (play) {
            animationStrip.reelAnimations[index].gotoAndPlay(frame);
        }
        else {
            animationStrip.reelAnimations[index].gotoAndStop(frame);
        }
		
        animationStrip.addChild(animationStrip.reelAnimations[index]);
    };

    animationStrip.hideAllAnimations = function() {
        for (var i = 0; i < appertureHeight; ++i) {
           animationStrip.hideAnimation(i);
        }
    };


    reelAnimationManager.animationStrips.push(animationStrip);
    return animationStrip;
};
reelAnimationManager.destroyAnimationStrip = function(animationStrip) {
	var index = standardObjectFactory.buttons.indexOf(animationStrip);
    if (index === -1) {
        console.log("Could not destroy animation strip as it could not be found");
        return;
    }

    standardObjectFactory.animationStrips.splice(index, 1);
};
reelAnimationManager.initialiseAnimationStrip = function(json, container) {
	container.linkedReel = resourceManager.get(json.reel);
	container.linkedReel.linkAnimation(container, json.FQN);
};


resourceManager.registerObjectType("reelAnimationStrip", reelAnimationManager.createAnimationStrip, reelAnimationManager.initialiseAnimationStrip, reelManager.getReelFiles, reelAnimationManager.destroyAnimationStrip);

